import { Comune } from "./comune";

export class DocumentoIdentita {
    id: number;
    numero: string;
    idComune: number;
    comune: Comune;
    dataScadenza: Date;
    dataNascita: Date;

    constructor(){
        this.comune = new Comune();
    }
}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/models/documento-identita.ts